// @ts-ignore
import GCLogo from "../../assets/img/growthcloud/growthcloud_wordmark.svg";

export default function NotFoundView() {
  return (
    <div className="h-100vh d-flex justify-content-center align-items-center bg-superlight">
      <div
        className="btn-oauth px-2 px-sm-6 py-4 bg-white mx-2 rounded-sm"
        style={{ maxWidth: 600, width: "100%" }}
      >
        <div className="d-flex justify-content-center mb-4">
          <img alt="" src={GCLogo} style={{ width: 170 }} />
        </div>
        <h2 className="text-center">Page Not Found</h2>
        <p className="text-center">
          Sorry, but the item you're looking for could not be found.
        </p>
      </div>
    </div>
  );
}
